import { useIsDesktop } from '@/_hooks/useBreakpoint';

import React from 'react';
import DeliveryDesktop from './delivery.desktop';
import DeliveryMobile from './delivery.mobile';

export interface IProps {
  handleOpenMap: (e?: any) => void;
}

const DeliveryType = (props: IProps) => {
  const isDesktop = useIsDesktop();

  return (
    <>
      {isDesktop ? (
        <DeliveryDesktop {...props} />
      ) : (
        <DeliveryMobile {...props} />
      )}
    </>
  );
};

export default DeliveryType;
